import StorageSaver from '../../classes/StorageSaver';

const playerProgressSaver = new StorageSaver('catalog-player-progress', true);

export default playerProgressSaver